import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { AGENTS } from "@/lib/brand";

export default function Agents() {
  return (
    <div data-testid="agents-page" className="min-h-screen bg-[#0A0A0A] grain">
      <Nav />

      <section className="pt-40 md:pt-56 pb-24 px-6 md:px-12">
        <div className="mx-auto max-w-[1500px]">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tight text-white max-w-4xl"
          >
            Meet the <em className="text-[#CBBFAE]">Watson Group</em> team.
          </motion.h1>
          <p className="mt-10 max-w-xl text-white/60 leading-relaxed">
            When you work with the Watson Group you get the utmost care from all members of the team. We are a family who care about each other as much as we care about our clients.
          </p>
        </div>
      </section>

      <section className="pb-32 md:pb-48 px-6 md:px-12">
        <div className="mx-auto max-w-[1500px] space-y-24 md:space-y-32">
          {AGENTS.map((agent, i) => (
            <motion.article
              key={agent.id}
              data-testid={`agent-bio-card-${agent.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1 }}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center ${i % 2 === 1 ? "md:direction-rtl" : ""}`}
            >
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <motion.div
                  initial={{ opacity: 0, scale: 1.06 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, amount: 0.15 }}
                  transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
                  className="relative aspect-[4/5] overflow-hidden bg-[#121212]"
                >
                  <img src={agent.photo} alt={agent.name} className="w-full h-full object-cover" style={{ filter: "grayscale(15%) brightness(0.95)" }} />
                </motion.div>
              </div>

              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1 md:pr-16" : "md:pl-8"}`}>
                <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-white mb-8">
                  {agent.name}
                </h2>
                <p className="text-white/60 leading-relaxed max-w-md mb-10">
                  {agent.bio}
                </p>
                {(agent.phone || agent.instagram || agent.dre) && (
                  <div className="mb-8 space-y-2 text-white/75 text-sm">
                    {agent.dre && (
                      <div className="flex gap-4"><span className="overline text-white/40 w-24 shrink-0">DRE</span>{agent.dre}</div>
                    )}
                    {agent.phone && (
                      <div className="flex gap-4"><span className="overline text-white/40 w-24 shrink-0">Phone</span>{agent.phone}</div>
                    )}
                    {agent.contact && (
                      <div className="flex gap-4"><span className="overline text-white/40 w-24 shrink-0">Email</span>{agent.contact}</div>
                    )}
                    {agent.instagram && (
                      <div className="flex gap-4"><span className="overline text-white/40 w-24 shrink-0">Instagram</span>{agent.instagram}</div>
                    )}
                  </div>
                )}
                <a
                  href={`mailto:${agent.contact}`}
                  className="group inline-flex items-center gap-3 border border-white/20 hover:border-[#CBBFAE] rounded-full pl-6 pr-2 py-2 text-[12px] tracking-[0.25em] uppercase text-white transition-all"
                >
                  <span>Write to {agent.name.split(" ")[0]}</span>
                  <span className="w-9 h-9 rounded-full bg-[#CBBFAE] text-[#0A0A0A] flex items-center justify-center transition-transform group-hover:rotate-45">↗</span>
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <section className="pb-32 px-6 md:px-12">
        <div className="mx-auto max-w-[1500px] flex flex-col md:flex-row items-center justify-between gap-8 pt-16 border-t border-white/10">
          <p className="font-serif text-3xl md:text-4xl text-white leading-tight max-w-md">
            Ready to begin?
          </p>
          <Link to="/#contact" className="group inline-flex items-center gap-4 border border-[#CBBFAE]/60 hover:border-[#CBBFAE] rounded-full pl-6 pr-2 py-2 text-[12px] tracking-[0.25em] uppercase text-white transition-all">
            <span>Contact the Team</span>
            <span className="w-10 h-10 rounded-full bg-[#CBBFAE] text-[#0A0A0A] flex items-center justify-center transition-transform group-hover:rotate-45">↗</span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
